import { useState, useEffect, useCallback, useMemo } from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import "../assets/css/navigationBar.css";
import logo from "../assets/images/logo.png";
import { UsersController } from "../controllers/usersController";
import { useNavigate } from "react-router-dom";
import { useToastPromise } from "../components/toastPromise";
import { Loading } from "../components/loading";
import { Status } from "../constants/status";
import { CgProfile } from "react-icons/cg";

export const NavigationBar = ({ navigationBar, cafeLogo }) => {
  const toastPromise = useToastPromise();
  const [name, setName] = useState("home");
  const [scrolled, setScrolled] = useState(false);
  const [user] = useState(() => JSON.parse(localStorage.getItem("user")));
  const [loading, setLoading] = useState(true);
  const [navbarExpanded, setNavbarExpanded] = useState(false);
  const [authLinks, setAuthLinks] = useState([]);
  const [mainLinks, setMainLinks] = useState([]);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const handleLogout = useCallback(
    (name) => {
      if (name === "logout") {
        toastPromise({
          promise: new Promise((resolve, reject) => {
            UsersController.logout({ resolve, reject });
          }),
          successMessage: (data) => data,
          errorMessage: (data) => data,
          finishPromise: () => {
            setLoading(false);
            navigate(0);
          },
        });
      } else {
        setName(name);
      }
    },
    [toastPromise, navigate]
  );
  useEffect(() => {
    setLoading(!navigationBar);
    const authItems = navigationBar.filter((nav) =>
      ["login", "signup", "logout"].includes(nav.name)
    );
    let mainItems = navigationBar.filter(
      (nav) => !["login", "signup", "logout"].includes(nav.name) && nav.isNavBar
    );
    const landingIndex = mainItems.findIndex((nav) => nav.name === "landing");
    if (landingIndex === -1) {
      const middleIndex = Math.floor(mainItems.length / 2);
      mainItems.splice(middleIndex, 0, { name: "landing", href: "/" });
    }
    setAuthLinks(authItems);
    setMainLinks(mainItems);
  }, [navigationBar, cafeLogo]);
  useEffect(() => {
    const handleScroll = () => {
      requestAnimationFrame(() => setScrolled(window.scrollY > 50));
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  const handleClick = (navBar) => {
    if (navBar.status !== Status.COMINGSOON) {
      if (navBar.name === "logout") {
        handleLogout(navBar.name);
      } else if (navBar.href.startsWith("#")) {
        const targetElement = document.querySelector(navBar.href);
        if (targetElement) {
          targetElement.scrollIntoView({ behavior: "smooth" });
        }
      } else if (/^https?:\/\//.test(navBar.href)) {
        window.location.href = navBar.href;
      } else if (navBar.href === "/loginSignUp") {
        const isLoginToggle = navBar.name === "login";
        navigate(navBar.href, { state: { isLoginToggle } });
      } else if (navBar.name === "reservations") {
        navigate(navBar.href);
      } else if (navBar.name === "landing") {
        window.location.reload();
      } else {
        navigate(navBar.href);
      }
    }
  };
  const renderedMainLinks = useMemo(
    () =>
      mainLinks.map((navBar, index) => (
        <Nav.Link
          key={navBar.name}
          className={`navbar-link ${name === navBar.name ? Status.ACTIVE : ""}`}
          onClick={() => handleClick(navBar)}
        >
          {navBar.name === "landing" ? (
            <img className="logo" src={cafeLogo ? cafeLogo : logo} alt="Logo" />
          ) : (
            <div className="nav-item-container">
              <span>{index === 0 ? "Home" : navBar.label}</span>
              {navBar.status === Status.COMINGSOON && (
                <span className="coming-soon-overlay">
                  {Status.getStatusValue(Status.COMINGSOON)}
                </span>
              )}
            </div>
          )}
        </Nav.Link>
      )),
    [mainLinks, name, handleClick, cafeLogo]
  );
  const renderedAuthLinks = useMemo(
    () =>
      authLinks.map((navBar) => (
        <Nav.Link
          key={navBar.name}
          className="navbar-link auth-link"
          onClick={() => handleClick(navBar)}
        >
          {navBar.status === Status.COMINGSOON
            ? null
            : navBar.name === "login" || navBar.name === "signup"
            ? user
              ? null
              : navBar.label
            : navBar.name === "logout"
            ? user
              ? navBar.label
              : null
            : null}
        </Nav.Link>
      )),
    [authLinks, handleClick]
  );

  return loading ? (
    <Loading />
  ) : (
    <Navbar expand="md" className={scrolled ? "scrolled" : ""}>
      <Container>
        <Navbar.Toggle
          aria-controls="basic-navbar-nav"
          onClick={() => setNavbarExpanded((prev) => !prev)}
        >
          <span className="navbar-toggler-icon"></span>
        </Navbar.Toggle>
        <Navbar.Collapse
          id="basic-navbar-nav"
          className={navbarExpanded ? "show" : ""}
        >
          <Nav className="me-auto">{renderedMainLinks}</Nav>
        </Navbar.Collapse>
        <CgProfile onClick={() => setOpen(!open)} className="auth-icon" />
        {open && <div className="auth-links">{renderedAuthLinks}</div>}
      </Container>
    </Navbar>
  );
};
